(function () {
  'use strict';

  var _swat;

  function refreshCount() {
    if (!_swat) return;
    _swat.fetch(function (items) {
      var list = items || [];
      setCount(list.length);
      document.dispatchEvent(new CustomEvent('on:wishlist:state', { detail: { items: list } }));
    });
  }

  function setCount(count) {
    var badge = document.querySelector('.header-wishlist-link__count');
    if (!badge) return;
    badge.textContent = count > 0 ? String(count) : '';
    badge.hidden = count === 0;
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    _swat = swat;
    var link = document.querySelector('.header-wishlist-link');
    if (link) link.hidden = false;
    refreshCount();
  });

  document.addEventListener('on:wishlist:changed', refreshCount);
})();
